import * as React from 'react';
import {CartProvider} from 'react-use-cart';

import '@common/react/yupLocaleSettings';
import {LoadingProvider} from '@common/react/components/Core/LoadingProvider/LoadingProvider';
import VideoChatModal from '@common/react/components/UI/VideoChat/VideoChatModal';
import ErrorBoundaryWithSentry from '@common/react/components/UI/ErrorBoundaryWithSentry/ErrorBoundaryWithSentry';
import SignalRChats from '@common/react/components/Chat/SignalRChats';
import { ChatSettingsProvider } from '@common/react/components/Chat/ChatSettingsProvider';
import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import HeaderSearch from '@app/components/UI/Header/HeaderSearch';
import PortalLoader from '@app/components/UI/PortalLoader';

import '@app/scss/style.scss';

const Layout: React.FC<{}> = ({children}) => <div className="app-container schema-gray-orange">
	<ErrorBoundaryWithSentry>
		<LoadingProvider loader={<PortalLoader/>}>
			<CartProvider>
				<HeaderSearch/>
				<RequestProvider>
					<ChatSettingsProvider
						title=""
						formSettings={{
							maxAttachmentsCount: 5,
							maxMessageLength: 500,
							sendByEnter: false,
							allowPasteImages: true,
							waveColor: '#f60',
							underFormLabel: 'Press Ctrl+Enter to send a message'
						}}
					>
						{children}
						<SignalRChats/>
					</ChatSettingsProvider>
					<VideoChatModal />
				</RequestProvider>
			</CartProvider>
		</LoadingProvider>
	</ErrorBoundaryWithSentry>
</div>;

export default Layout;